export default "__VITE_ASSET__C5Qz1sq$__"